import {
	getCartNumApi,
	cartListApi
} from '../../api/cart/index'
import toast from '../../components/tf-toast'
export default {
	namespaced: true,
	state: {
		cartList: [],
		cartHelper: {},
		// 购物车总数
		cartNum: null,
		checkedAmount:0,
		allAmount:0
	},
	mutations: {
		setCartList (state, data) {
			state.cartList = data
		},
		setCartNum (state, data) {
			state.cartNum = data
		},
		setCheckedAmount (state, data) {
			state.checkedAmount = data
		},
		setAllAmount (state, data) {
			state.allAmount = data
		},
		setCartHelper (state, cartHelper) {
			state.cartHelper = cartHelper
		}
	},
	actions: {
		// 获取购物车数据
		/**
		 * @description 
		 * 新人&特价活动 和普通商品 公用一个goodsId，货架中只展示同一个goodsId的加车数量之和，
		 * 但是购物车列表接口 返回相同goodsId的n条数据，所以购物车页面暂不能调用改方法，需要单独调用购物车列表接口单独处理。
		 * @param {*} param0 
		 * @param {*} param 
		 * @returns 
		 */
		getCartList({
			commit,
			state
		}, param){
			try {
				return new Promise(async(resolve,reject)=>{
					const params = {
						// isSupplier: param?.dealerId ? 0 : 1 // 是否是经销商 0=是，1=不是
					}
					// if(param?.dealerId){ // 经销商id
					// 	params.dealerId = param.dealerId
					// }
					const result = await cartListApi(params)			
					if(result?.code === 0){
						const { validGoodsList: cartList = []} = result?.data || {}
						// 合并购物车数据
						let mergeCartList = []

						// 有可能返回的数据是原始格式 做兼容处理
						if (Array.isArray(cartList)) {
							mergeCartList = cartList.length && cartList.reduce((pre,next) => {
								return pre.concat(next)
							})
							commit('setCartList', mergeCartList)
						}
						// 清空cartHelper
						commit('setCartHelper', {})

						const cartHelper = {}
						mergeCartList && mergeCartList.forEach(c => {
							if(cartHelper[c.goodsId]){ // tips：新人&特价活动公用一个goodsId，故 除了购物车列表外，需要合并同一个goodsId的加车数量
								cartHelper[c.goodsId].num = cartHelper[c.goodsId].num + c.number
							}else{
								cartHelper[c.goodsId] = {
									id: c.skuId,
									goodsId: c.goodsId,
									num: c.number
								}
							}
						})
						// 更新cartHelper
						commit('setCartHelper', cartHelper)

						let sum = 0
						if (Object.values(cartHelper).length) {
							Object.values(cartHelper).forEach((item) => {
								sum += Number(item.num)
							})
						}
						commit('setCartNum', sum)
						if(result.data){
							commit('setCheckedAmount',result.data.checkedAmount)
							commit('setAllAmount',result.data.allAmount)
						}else{
							commit('setCheckedAmount',0)
							commit('setAllAmount',0)
						}
						resolve(result?.data || [])
						return
					}
          toast({
            title: result.msg || '数据异常'
          })
				})
			} catch (error) {
				console.log('获取购物车数据error:', error)
			}
		},
		// 获取购物车数量
		fetchCartNum ({
			commit
		}, param = {}) {
			return new Promise((resolve, reject) => {
				let tempApi =null
				if(param?.dealerId){ //经销商
					tempApi = getCartCount
				}else{
					tempApi = getCartNumApi
				}
				tempApi(param).then(res => {
					if (res.code) return
					commit('setCartNum', res.data || 0)
					resolve(res.data || 0)
				}).catch((err) => {
					console.log('cart num error:', err)
					reject(err)
				})
			})
		}
	}
}
